import _PropTypes from 'prop-types';
import styled from 'styled-components';
import { neutralColors, alertColors } from '../../styles/colors/colors.js';
import { spacing4x, spacing2x } from '../../styles/spacing.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var StyledFormField = styled.div.withConfig({
  displayName: "FormField__StyledFormField",
  componentId: "sc-1yill90-0"
})(["&&{margin-bottom:", ";}"], spacing4x);
var FormFieldLabel = styled.label.withConfig({
  displayName: "FormField__FormFieldLabel",
  componentId: "sc-1yill90-1"
})(["&&{font-weight:bold;color:", ";display:block;margin-bottom:5px;text-overflow:ellipsis;white-space:nowrap;", ";}"], neutralColors.charcoal, function (props) {
  return props.required && "\n        &:after {\n            content: \"*\";\n            color: ".concat(alertColors.error, ";\n            font-size: 12px;\n            margin-left: 5px;\n            vertical-align: middle;\n        }\n    ");
});
var FormFieldDescription = styled.div.withConfig({
  displayName: "FormField__FormFieldDescription",
  componentId: "sc-1yill90-2"
})(["&&{color:", ";font-size:12px;margin-bottom:5px;}"], neutralColors.smoke);
var FormFieldError = styled.div.withConfig({
  displayName: "FormField__FormFieldError",
  componentId: "sc-1yill90-3"
})(["&&{color:", ";font-weight:bold;font-size:13px;margin-top:", ";}"], alertColors.error, spacing2x);

function FormField(props) {
  return /*#__PURE__*/jsxs(StyledFormField, {
    className: props.className,
    children: [props.label && /*#__PURE__*/jsx(FormFieldLabel, {
      htmlFor: props.htmlFor,
      id: props.id,
      required: props.required,
      children: props.label
    }), props.description && /*#__PURE__*/jsx(FormFieldDescription, {
      children: props.description
    }), props.children, props.error && /*#__PURE__*/jsx(FormFieldError, {
      children: props.errorMessage
    })]
  });
}

FormField.propTypes = {
  "children": _PropTypes.node,
  "className": _PropTypes.string,
  "description": _PropTypes.string,
  "error": _PropTypes.bool,
  "errorMessage": _PropTypes.string,
  "htmlFor": _PropTypes.string,
  "id": _PropTypes.string,
  "label": _PropTypes.string,
  "required": _PropTypes.bool
};
FormField.displayName = "FormField";

export { FormField, FormFieldDescription, FormFieldError, FormFieldLabel };
